import { Box, AppBar, Toolbar, Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useCustomerValue } from "providers/CustomerContext";

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#7586dd",
    },
  },
});

function Navbar() {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        color="default"
        position="static"
        sx={{ borderRadius: "2px", backgroundColor: "#e6eaf9" }}
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Select />
        </Toolbar>
      </AppBar>
    </Box>
  );
}

const Select = () => {
  const { customerCode, setCustomerCode, customerOpt } = useCustomerValue();
  return (
    <Box sx={{ width: "200px" }}>
      <Autocomplete
        options={customerOpt ?? []}
        disableClearable
        value={customerCode}
        onChange={(event, v) => {
          setCustomerCode(v);
        }}
        sx={{ "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } }}
        renderInput={(params) => <StyledTextField label="Customer Code" {...params} />}
      />
    </Box>
  );
};

export default Navbar;
